/**
 * Office JSON populate function
 * Revendor is sent under the "rv" variable. Contains key and revendor ID
 */

declare const AJAX_BASE: string;

import { logger } from "./utils.js";

/**
 * 
 * @return array res
 * List of offices extracted from JSON list of office / city combinations for T and Fs. 
 */
 async function ajax_offices(lang:string) {

  logger("ajax call - offices");

  let res = ["ERROR"]; 

  try {

    let endpoint = AJAX_BASE + "_ajax_oficina_list_int.php";

    if (lang=="ENG") {
      endpoint = AJAX_BASE + "_ajax_oficina_list_eng.php";
    }
    
    res = await fetch(endpoint)
    .then((response) => {
      return response.json();
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      logger("error definición oficinas","error");
      return(["ERROR"]);
    });

  } catch (err) {
    logger("error cargando oficinas","error");
    return(["ERROR"]);
  }

  return res;

}



/**
 * 
 * @return array res
 * List of vehicle matches for search combination combinations for T and Fs. 
 */
async function  ajax_alternative_offices( data:{} ) {

  logger("ajax call - alternative offices ");

  let res = {status: "ERROR", result: [], errno: null }; 

  // separate data into URL string: 
  let data_str = "";
  
  data_str = Object.keys(data).map( (key) => {
    // @ts-ignore
    return key + '=' + encodeURIComponent(  data[key]  );
  }
  ).join('&');


  try {

    res = await fetch(AJAX_BASE + "_ajax_stepgeosearch.php?" + data_str)
    .then((response) => {
      return response.json();
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      logger("error solicitando oficinas", "error");
      return res; 
    });

  } catch (err) {
    logger("error conectando con servidor oficinas", "error");
    return res; 
  }

  return res;

}




/**
 * 
 * @return array res
 * List of vehicle matches for search combination combinations for T and Fs. 
 */
async function  ajax_list_results( data:{} ) {

  logger("ajax call - result list");

  // separate data into URL string: 
  let data_str = "";
  
  data_str = Object.keys(data).map( (key) => {
    // @ts-ignore
    return key + '=' + encodeURIComponent(  data[key]  );
  }
  ).join('&');


  let res = {status: "ERROR", result: [] , errno: null }; 

  try {

    res = await fetch(AJAX_BASE + "_ajax_step1.php?" + data_str)
    .then((response) => {
      return response.json();
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      logger("error solicitando resultados", "error");
      return res; 
    });

  } catch (err) {
    logger("error conectando con servidor resultados", "error");
    return res; 
  }

  return res;

}




/**
 * 
 * @return array res
 * List of vehicle matches for search combination combinations for T and Fs. 
 */
async function  ajax_list_detail( data:{} ) {

  logger("ajax call - car detail");

  // separate data into URL string: 
  let data_str = "";
  
  data_str = Object.keys(data).map( (key) => {
    // @ts-ignore
    return key + '=' + encodeURIComponent(  data[key]  );
  }
  ).join('&');


  let res = {status: "ERROR", result: [] , errno: null }; 

  try {

    res = await fetch(AJAX_BASE + "_ajax_step2.php?" + data_str)
    .then((response) => {
      return response.json();
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      logger("error solicitando detalle", "error");
      return res; 
    });

  } catch (err) {
    logger("error conectando con servidor detalle", "error");
    return res; 
  }

  return res;

}





/**
 * 
 * @return array res
 * Save reservation request to GESEMAL DB and return reservation ID.
 * Send as POST (others use GET).
 */
async function ajax_book_reserva( data:{}, gclid:string ) {

  logger("ajax call - book reserva");

  let res = {status: "ERROR", result: [] , errno: null }; 

  // Use URLSearchParams to send data as POST in format compatible with PHP:
  try {

    res = await fetch(
      AJAX_BASE + "_ajax_step3.php", {
        method: "POST",
        body: new URLSearchParams({
          'tipo_c': JSON.stringify({
            "data": data,
            "gclid": gclid,
          })
      })

    })
    .then((response) => {
      return response.json();
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      logger("error solicitando reserva", "error");
      return res; 
    });

  } catch (err) {
    logger("error conectando con servidor reserva", "error");
    return res; 
  }

  return res;

}




/**
 * 
 * @return array res
 * Will return status of the reservation. ["A"uth, "R"eject, "P"ending, "X"pired].
 * And status code (errno).
 */
async function  ajax_ping_status( data:{} ) {

  logger("ajax call - check status");

  // separate data into URL string: 
  let data_str = "";
  
  data_str = Object.keys(data).map( (key) => {
    // @ts-ignore
    return key + '=' + encodeURIComponent(  data[key]  );
  }
  ).join('&');


  let res = {status: "ERROR", result: [] , errno: null }; 

  try {

    res = await fetch(AJAX_BASE + "_ajax_check_status.php?" + data_str)
    .then((response) => {
      return response.json();
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      logger("error solicitando detalle", "error");
      return res; 
    });

  } catch (err) {
    logger("error conectando con servidor detalle", "error");
    return res; 
  }

  return res;

}





/**
 * 
 * @return array res
 * Passes URL link to server to send to client to retrieve search
 * Format determined by server (other sites use same endpoint).
 */
async function ajax_save_search( url:string, ref: string, eml:string) {

  logger("ajax call - save search to client email ");

  let res = {status: "ERROR", result: [], errno: null }; 

  try {

    res = await fetch(
      AJAX_BASE + "_ajax_stepsearch_guardar.php", {
        method: "POST",
        body: new URLSearchParams({
          'ref': ref,
          'srch': url,
          'eml': eml
          })
    })
    .then((response) => {
      return response.json();
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      logger("error guardando reserva", "error");
      return res; 
    });

  } catch (err) {
    logger("error conectando con servidor de reservas", "error");
    return res; 
  }

  return res;

}









export { ajax_offices, ajax_alternative_offices, 
        ajax_list_results, ajax_list_detail, 
        ajax_book_reserva, ajax_ping_status,
        ajax_save_search };